//src/components/callback.js
import React, { Component } from "react";

import withRouter from "../../src/hocs/withRouter";
import loading from "../img/loading.svg";
import axios from "axios";
import { isMsalMode } from "../lib/authMode";

class Callback extends Component {
  componentDidMount() {
    // console.log("Callback component mounted");
    // console.log("Location hash:", this.props.location?.hash || window.location.hash);

    // msal mode: the server completed the login (SAML or Azure) and set the
    // session cookie before redirecting here, so there is no token to process -
    // just continue to where the user was headed.
    if (isMsalMode()) {
      // /setClient (ovis "preview as client") shares this component, but App
      // redeems its one-time token and navigates on once the session exists.
      if (window.location.pathname.includes("/setClient")) return;
      const target = localStorage.getItem("continueUrl");
      if (target && target !== "/" && target !== "/index.html" && target !== "/callback") {
        localStorage.removeItem("continueUrl");
        this.props.navigate(target, { replace: true });
      } else {
        this.props.navigate("/", { replace: true });
      }
      return;
    }

    let hash = this.props.location?.hash || window.location.hash;
    
    // FIRST: Check if the URL contains sso_token - this takes priority over localStorage
    if (hash.includes("sso_token")) {
      // console.log("Detected sso_token in URL hash - handling SSO authentication");
      
      if (this.props.auth) {
        this.props.auth.handleSSOAuth();

        // Redirect after authentication
        setTimeout(() => {
          // console.log("✅ SSO Authentication complete! Redirecting...");

          const continueUrl = localStorage.getItem("continueUrl");

          if (continueUrl && continueUrl !== "/" && continueUrl !== "/index.html" && continueUrl !== "/callback") {
            // console.log("Redirecting to continueUrl:", continueUrl);
            this.props.navigate(continueUrl, { replace: true });
            localStorage.removeItem("continueUrl");
          } else {
            // console.log("Redirecting to home");
            this.props.navigate("/", { replace: true });
          }
        }, 1000);
      } else {
        console.error("❌ Auth object not available on props");
      }
      return; // Exit early - don't fall through to other logic
    }

    let sso = localStorage.getItem("sso");
    // console.log("SSO value:", sso, "Type:", typeof sso);

    // Check for non-SSO authentication (sso is null, "false", or false)
    if (sso === "false" || sso === null || sso === false) {
      // console.log("Handling non-SSO authentication");

      // Check if this is a token renewal (token=) or initial auth (id_token=)
      if (hash.includes("token=")) {
        let idToken = hash.split("token=")[1];
        // console.log("ID TOKEN RENEWAL");
        axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
      } else if (hash.includes("id_token=")) {
        let idToken = hash.split("id_token=")[1].split("&")[0];
        // console.log("ID TOKEN INITIAL AUTH - Token length:", idToken.length);
        axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
      }

      // Process the authentication
      if (this.props.auth) {
        // console.log("Calling handleAuthentication...");
        this.props.auth.handleAuthentication();

        // Check if authentication was successful
        setTimeout(() => {
          const accessToken = localStorage.getItem("access_token");
          const expiresAt = localStorage.getItem("expires_at");
          const user = localStorage.getItem("user");
          const ssoAfterAuth = localStorage.getItem("sso");

          // console.log("After handleAuthentication:");
          // console.log("- access_token exists:", !!accessToken);
          // console.log("- access_token length:", accessToken ? accessToken.length : 0);
          // console.log("- expires_at:", expiresAt);
          // console.log("- user:", user);
          // console.log("- sso:", ssoAfterAuth);
          // console.log("- isAuthenticated:", this.props.auth.isAuthenticated());
          // // ADD THIS - Check axios default headers
          // console.log(
          //   "- axios Authorization header:",
          //   axios.defaults.headers.common["Authorization"]?.substring(0, 100) + "...",
          // );

          if (!accessToken || !expiresAt) {
            console.error("❌ Authentication failed - tokens not saved to localStorage");
            // Stay on callback page to debug
            return;
          }

          // console.log("✅ Authentication successful! Redirecting...");

          const continueUrl = localStorage.getItem("continueUrl");

          if (continueUrl && continueUrl !== "/" && continueUrl !== "/index.html" && continueUrl !== "/callback") {
            // console.log("Redirecting to continueUrl:", continueUrl);
            this.props.navigate(continueUrl, { replace: true });
            localStorage.removeItem("continueUrl");
          } else {
            // console.log("Redirecting to home");
            this.props.navigate("/", { replace: true });
          }
        }, 1000);
      } else {
        console.error("❌ Auth object not available on props");
      }
    }
    // Handle SSO authentication
    else if (sso === "true" || sso === true) {
      // console.log("Handling SSO authentication");

      if (this.props.auth) {
        // console.log("Calling handleSSOAuth...");
        this.props.auth.handleSSOAuth();

        // Redirect after authentication
        setTimeout(() => {
          // console.log("✅ SSO Authentication complete! Redirecting...");

          const continueUrl = localStorage.getItem("continueUrl");

          if (continueUrl && continueUrl !== "/" && continueUrl !== "/index.html" && continueUrl !== "/callback") {
            // console.log("Redirecting to continueUrl:", continueUrl);
            this.props.navigate(continueUrl, { replace: true });
            localStorage.removeItem("continueUrl");
          } else {
            // console.log("Redirecting to home");
            this.props.navigate("/", { replace: true });
          }
        }, 1000);
      }
    }
    // Fallback - shouldn't happen
    else {
      console.warn("⚠️ Unexpected SSO value:", sso);
      // console.log("Attempting handleAuthentication anyway...");

      if (this.props.auth) {
        this.props.auth.handleAuthentication();

        setTimeout(() => {
          this.props.navigate("/", { replace: true });
        }, 1000);
      }
    }
  }

  render() {
    const style = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100%",
      backgroundColor: "white",
    };

    return (
      <div style={style}>
        <img src={loading} alt="loading" style={{ width: "100px", height: "100px" }} />
        <div style={{ marginTop: "20px", textAlign: "center", fontSize: "14px", color: "#666" }}>
          Processing authentication...
        </div>
      </div>
    );
  }
}

export default withRouter(Callback);
